import cn from "classnames";
import { TableRowProps } from "./types";
import styles from "./styles.module.scss";

export const TableRow = ({
  children,
  className,
  dataTestId,
  onClick,
  ...restProps
}: TableRowProps) => {
  const handleClick = () => {
    // INFO: Игнорируем событие клика если происходит выделение текста в строке таблицы
    if (!window.getSelection()?.isCollapsed) {
      return;
    }

    onClick?.();
  };

  return (
    <tr
      className={cn(styles["table-row"], className)}
      onClick={handleClick}
      data-test-id={dataTestId}
      {...restProps}
    >
      {children}
    </tr>
  );
};
